import React, { useEffect, useState } from 'react';
import onboadBackground from '../../assets/images/onboad_background.png';
import onboadImage from '../../assets/images/onboard_image.png';
import { useWhitelabel } from '../../contexts/WhitelabelContext';

interface OnboardingLayoutProps {
  children: React.ReactNode;
}

export const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  children,
}) => {
  const { appName, logoFull } = useWhitelabel();
  const [backgroundLoaded, setBackgroundLoaded] = useState(false);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [mockupLoaded, setMockupLoaded] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);

  const allImagesLoaded = backgroundLoaded && logoLoaded && mockupLoaded;

  // Only show spinner after 50ms delay
  useEffect(() => {
    const timer = setTimeout(() => {
      if (!allImagesLoaded) {
        setShowSpinner(true);
      }
    }, 50);
    return () => clearTimeout(timer);
  }, [allImagesLoaded]);

  return (
    <div className="relative flex h-screen w-full items-center justify-center overflow-hidden bg-white">
      {/* Background gradient SVG */}
      <img
        src={onboadBackground}
        alt="Onboarding Background"
        className="absolute inset-0 h-full w-full object-cover"
        onLoad={() => setBackgroundLoaded(true)}
      />

      {/* Logo */}
      <img
        src={logoFull}
        alt={`${appName} Logo`}
        className="absolute left-1/2 top-11 h-10 w-[175px] -translate-x-1/2"
        onLoad={() => setLogoLoaded(true)}
      />

      {/* Content */}
      <div className="relative z-10 px-2 sm:px-0">{children}</div>

      {/* Background image (mockup) */}
      <div className="absolute inset-x-0 bottom-0 hidden animate-[breath_5s_ease-in-out_infinite] md:block">
        <img
          className="rounded-tl-5xl m-auto w-[70vw] rounded-tr-[] object-cover"
          src={onboadImage}
          alt="Onboarding Mockup"
          onLoad={() => setMockupLoaded(true)}
        />
      </div>

      {/* Loading overlay */}
      <div
        className={`absolute inset-0 z-50 flex items-center justify-center bg-white transition-opacity duration-300 ${
          allImagesLoaded ? 'pointer-events-none opacity-0' : 'opacity-100'
        }`}
      >
        {showSpinner && (
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-violet-600" />
        )}
      </div>
    </div>
  );
};
